<template>
<div class="row">

	<div class="col-12">
		<partial-loader :loading="isFetching"></partial-loader>
	</div>

	<div class="col">

		<table class="table b-table table-striped table-hover"
		       v-if="!isFetching && bidNumbers.length > 0">
			<thead>
				<tr>
					<th>Biednummer</th>
					<th>Veiling</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="bidNumber in bidNumbers">
					<td>
						<h3>{{ bidNumber.bid_number }}</h3>
					</td>
					<td>{{ bidNumber.auction.title }}</td>
					<td>
						<b-btn variant="outline-danger"
						       @click="showDeleteModal(bidNumber)"
						       size="sm"><i class="fa fa-fw fa-trash"></i></b-btn>
					</td>
				</tr>
			</tbody>
		</table>

		<p v-if="bidNumbers.length === 0">
			Nog geen biednummers.
		</p>

		<div class="row">
			<div class="col-12">
				<b-alert v-if="formError"
				         show
				         variant="warning">
					<span v-for="errors in formError.errors">
							 <span v-for="error in errors">{{ error }}<br /></span>
					</span>
				</b-alert>
			</div>

			<div class="col col-sm-3">
				<b-form-group label="Biednummer:">
					<b-form-input autocomplete="off" v-model="form.bid_number"></b-form-input>
				</b-form-group>
			</div>
			<div class="col">
				<autocomplete-auction label="Veiling"
				                      :selected="form"
				                      placeholderLabel=""
				                      @update:auction="updateAuctionId"></autocomplete-auction>
			</div>
			<div class="col-2">
				<b-form-group label="&nbsp;">
					<b-btn @click="addBidNumber"
					       variant="outline-primary"
					       block><i class="fa fa-fw fa-plus"></i></b-btn>
				</b-form-group>
			</div>
		</div>

	</div>

	<delete-dialog-modal ref="deleteModal"
	                     :delete-name="getDeleteTitle()"
	                     :item="bidNumberToDelete"
	                     :isDeleting="isDeleting"
	                     @confirm="deleteBidNumber"></delete-dialog-modal>
</div>
</template>

<script>
import { isNil, pick, forOwn, keys, find } from 'lodash';
import PersonService from '@/services/person-service';
import BidNumberService from '@/services/bid-number-service';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import AutocompleteAuction from '@/components/elements/AutocompleteAuction';

export default {
	components: {
		PartialLoader,
		DeleteDialogModal,
		AutocompleteAuction
	},
	data() {
		return {
			isFetching: true,
			isDeleting: false,
			mode: 'add',
			bidNumbers: [],
			formError: false,
			form: {
				bid_number: '',
				auction_id: ''
			},
			bidNumberToDelete: false
		}
	},
	methods: {
		getDeleteTitle() {
			if (!this.bidNumberToDelete) return '';

			return `Biednummer "${this.bidNumberToDelete.bid_number}" voor veiling "${this.bidNumberToDelete.auction.title}"`;
		},
		updateAuctionId(auction) {
			if (!isNil(auction))
				this.form.auction_id = auction.id;
		},
		fetchBidNumbers() {
			this.isFetching = true;

			const params = {
				page: 1,
				total: 1000,
				sort: 'id',
				order: 'desc'
			};

			return BidNumberService.getByPersonId(this.$route.params.personId, params)
				.then(response => {
					this.isFetching = false;
					this.bidNumbers = response;
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.message;
				});
		},
		addBidNumber() {
			this.formError = false;
			this.isFetching = true;

			const params = {
				person_id: this.$route.params.personId,
				auction_id: this.form.auction_id,
				bid_number: this.form.bid_number
			};

			return BidNumberService.create(params)
				.then(response => {
					this.fetchBidNumbers()
						.then(() => this.form = { bid_number: '', auction_id: '' })
				})
				.catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
		},
		/**
		 * Show delete modal for the bid number
		 * @param  {Object} bidNumber
		 */
		showDeleteModal(bidNumber) {
			this.bidNumberToDelete = bidNumber;
			this.$refs.deleteModal.show();
		},
		/**
		 * Delete the bid number and refresh the bidnumbers
		 * @param  {Object} bidNumber  bidNumber that will be deleted
		 * @return {Promise}
		 */
		deleteBidNumber(bidNumber) {
			this.isDeleting = true;
			return BidNumberService.delete(bidNumber.id)
				.then(() => {
					this.isDeleting = false;
					this.$refs.deleteModal.hide();
					this.fetchBidNumbers();
				});
		},
	},
	mounted() {
		if (!isNil(this.$route.params.personId)) {
			this.mode = 'edit';
			this.fetchBidNumbers();
		} else {
			this.isFetching = false;
		}
	}
}
</script>



// WEBPACK FOOTER //
// PersonBidNumbers.vue?3f7545f9